import Vue from 'vue'
import { GetRequest } from '@/utils/utils'
import router from '../../router'
import store from '../../store'
import { paymentRetentionPopStatus, paymentRetentionGiftCoupon } from "@http/overview/index";
const state = {
    routerArray: [],
    basic: '',
    metaName: '',
    basicPath: '',
    // 控制导航菜单可点击 默认可点击
    navBarMaskShow: false,
    payLeave: {}

}
const mutations = {
    setRouterInfo(state, newArray) {
        state.routerArray = newArray
    },
    setBasic(state, basic) {
        state.basic = basic
    },
    setMetaName(state, metaName) {
        state.metaName = metaName
    },
    setMetaPath(state, basicPath) {
        state.basicPath = basicPath
    },
    setNavBarMaskShow(state, navBarMaskShow) {
        state.navBarMaskShow = navBarMaskShow
    },
    setPayLeave(state, payLeave) {
        state.payLeave = payLeave
    },
}
const actions = {
    setRouter({ commit }, value) {
        let newArray = []
        let basic = ''
        let { basicName, basicRoute, basicTitle,basicPath } = value
        basicRoute.forEach((element, index1) => {
            if (element.children) {
                element.children.forEach((item, index) => {
                    if (item && item.meta.basicName === basicName) {
                        basic = item.meta.basic
                        newArray.push(item);
                        // if (get('userData').parentId == '0') {
                        //     newArray.push(item);
                        // } else {
                        //     if (!item.meta.isparent) {
                        //         newArray.push(item);
                        //     }
                        // }
                    }
                });
            }
        });
        commit('setRouterInfo', newArray)
        commit('setBasic', basic)
        commit('setMetaName', basicTitle)
        commit('setMetaPath', basicPath)
    },
    setNavBarMask({ state, commit, dispatch }) {
        // paymentRetentionPopStatus({
        //     suiteId: GetRequest().suiteId,
        //     buyCount: GetRequest().buyCount
        // }).then(({ popStatus, seqNo, discount }) => {
        //     // 是否弹窗（0 否 1 是
        //     if (popStatus === 1) {
        //         dispatch('setDiscountDialog', { seqNo, discount })
        //         this.setDiscountDialog({ seqNo, discount }) // 以后上线可以去掉
        //     } else {
        //         commit('setNavBarMaskShow', false)
        //     }
        // }).catch(() => {
        // })
        let payLeave = state.payLeave
        dispatch('setDiscountDialog', { payLeave })
    },
    setDiscountDialog({ commit }, { payLeave }) {
        let channelCodeValue = store.state.config.channelCodeValue
        // zhuge.track('支付挽留_web_弹窗弹出', {'渠道': channelCodeValue})
        // Vue.prototype.$TsaPayRetainDialog.show({
        //     discount,
        //     giveUp: () => {
        //         commit('setNavBarMaskShow', false)
        //         zhuge.track('支付挽留_web_关闭弹窗', {'渠道': channelCodeValue})
        //         Vue.prototype.$TsaPayRetainDialog.hide()
        //     },
        //     useCoupons: () => {
        //         zhuge.track('支付挽留_web_立即使用', {'渠道': channelCodeValue})
        //         paymentRetentionGiftCoupon({
        //             seqNo: seqNo,
        //         }).then((res) => {
        //             console.log(res)
        //             commit('setNavBarMaskShow', false)
        //             Vue.prototype.$TsaPayRetainDialog.hide()
        //             router.push({
        //                 path: '/userAccount/buy',
        //                 query: {
        //                     suiteId: GetRequest().suiteId,
        //                     buyCount: GetRequest().buyCount
        //                 }
        //             })
        //             // 此时couponId用的主键id 而不是couponId, id更具有唯一性
        //             window.sessionStorage.setItem('couponId', res.id)
        //         })
        //     }
        // })

        Vue.prototype.$TsaPayRetainDialog.show({
            payLeave,
            giveUp: () => {
                commit('setNavBarMaskShow', false)
                Vue.prototype.$TsaPayRetainDialog.hide()
            },
            useCoupons: () => {
                commit('setNavBarMaskShow', false)
                Vue.prototype.$TsaPayRetainDialog.hide()
                let traceName = '用户中心_弹窗广告位'
                let traceMap = {
                    '广告位名称': payLeave.name,
                    '页面名称': '微信支付页'
                }
                let { hrefUrl, openType } = payLeave
                // 当前页面跳转 1是当前页面 0是新开页面
                hrefUrl = hrefUrl || process.env.VUE_APP_GETREWARDS
                if (openType === 1) {
                    zhuge.track(traceName, traceMap, () => {
                        window.location.href = hrefUrl
                    })
                } else {
                    zhuge.track(traceName, traceMap)
                    window.open(hrefUrl, '_blank')
                }
            }
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};